import { Select } from 'antd'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useStores } from '../../cls/stores/MobXProvider'
import PropTypes from 'prop-types'
import { useSmartTranslation } from '../../cls/TranslationContext'
/**
 * AssignPlatformsInput renders a multi-select dropdown of active platforms assigned to a user.
 *
 * @component
 * @param {Object} props
 * @param {string} props.user_id      The ID of the user whose platforms to list.
 * @param {string[]} [props.value]    The currently selected platform IDs.
 * @param {function} props.onChange   Callback invoked when the selection changes.
 * @param {...any} [props]            Additional props passed to Ant Design Select.
 * @returns {JSX.Element} The rendered Select component with platform options.
 */
const AssignPlatformsInput = observer(
	({ user_id, value, onChange, ...props }) => {
		const { t } = useSmartTranslation()
		const { users } = useStores()
		const user = users.requireUserById(user_id)

		const options = user.platforms
			.filter((platform) => platform.status === 'active')
			.map((platform) => ({
				label: platform.name,
				value: platform.id
			}))
		return (
			<Select
				options={options}
				value={value}
				onChange={onChange}
				mode="multiple"
				allowClear
				placeholder={t('__assign%_platform.multiple')}
				style={{
					width: '100%'
				}}
				{...props}
			/>
		)
	}
)

AssignPlatformsInput.propTypes = {
	user_id: PropTypes.string.isRequired,
	value: PropTypes.arrayOf(PropTypes.string),
	onChange: PropTypes.func
}

export default AssignPlatformsInput
